import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'shared/lib/hooks/hooks';

const Description = () => {
  const { t } = useTranslation();
  const marathon = useAppSelector(
    (state) => state.marathons.marathonsById.response.data
  );

  const stripHtml = (html: string) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || '';
  }

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none"
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 600,
            color: "#0090D1",
            paddingBottom: "20px"
          }}>
          {t("myMarathon.description")}
        </Typography>
        <Typography>
          {marathon?.text ? stripHtml(marathon.text) : ''}
        </Typography>
      </Box>
    </Paper>
  );
};

export default Description;